/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A province in Canada.
 */
export enum Province {
    AB = 'AB',
    BC = 'BC',
    MB = 'MB',
    NB = 'NB',
    NL = 'NL',
    NT = 'NT',
    NS = 'NS',
    NU = 'NU',
    ON = 'ON',
    PE = 'PE',
    QC = 'QC',
    SK = 'SK',
    YT = 'YT',
}
